import { observable, action } from "mobx";
import { createContext } from "react";
import { IWorkorder } from "../models/workorder";
import { IVariation } from "../models/variation";
import agent from "../api/agent";
import { IVariationResponse } from "../models/variationresponse";

class VariationStore {
  @observable workorders: IWorkorder[] = [];
  @observable selectedWorkOrder: IWorkorder | undefined = undefined;
  @observable VariationsRequiringApprovals: IVariation[] = [];
  @observable loadinginitial = false;
  @observable settingapproval = false;
  @observable VariationResponse: IVariationResponse | undefined = undefined;

  @action setApprovalStatus = (
    id: string,
    result: string,
    decReason: string,
    user: string
  ) => {
    this.settingapproval = true;
    agent.Variations.SetApproval({
      clientid: "2B28C4A2-0894-E911-A978-002248072ABD", //CCHA For Now!
      username: user,
      varsorId: id,
      varId: null,
      timestamp: new Date(),
      status: result,
      approvedBy: user,
      appdecreason: decReason
    })
      .then(resp => (this.VariationResponse = resp))
      // .catch(error => {
      //   alert("Setting Approval Status Error: " + error);
      // })
      .finally(() => (this.settingapproval = false));

 
  };

  @action loadWorkOrderVariations = (id: string, username:string) => {
    if (username == undefined || username == null)
        username = ""
    agent.WorkOrderVariationHistory.list({
      clientid: "2B28C4A2-0894-E911-A978-002248072ABD", //CCHA For Now!
      username: username,
      wrkOrdId: id,
      timestamp: new Date()
    })
      .then(
        resp =>
          (this.VariationsRequiringApprovals = resp.filter(
            x => x.AppStatus === "Requires Approval"
          ))
      )
      .catch(error => {
        alert("Load Work Order Variations Error: " + error);
      });
  };
}

//Create new store in react context
export default createContext(new VariationStore());
